//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')

/**
 * The NewMatchDetailHomeMediator class maintains the business logic
 * for the new match detail home page.
 */
const tbs_controller_NewMatchDetailHomeMediator = function () {
  //--------------------------------------------------
  // super method for the base class
  //--------------------------------------------------
  ClassFunc.super(this, BaseMediator, arguments)
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_NewMatchDetailHomeMediator.prototype = {
  //--------------------------------------------------
  // api method
  //--------------------------------------------------
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_NewMatchDetailHomeMediator, BaseMediator);

module.exports = tbs_controller_NewMatchDetailHomeMediator
